import axios, { API_BASE, handler, provideFetchOptions, rawHandler } from './http-service';
import { FetchOptions } from '../components/interfaces';

const baseURL = `${API_BASE}/users`;

export const pureFetch = async (options?: FetchOptions) => {
  options = provideFetchOptions(options, { sort: 'name' });
  return rawHandler(() => axios.get(baseURL, { params: options }));
}

export const list = async (query?: any) => {
  return handler(() => axios.get(baseURL, { params: query }));
}

export const listCustomers = async (options = { all: false }) => {
  let url = `${baseURL}/?access=customer`;
  if (options.all) {
    url += '&all=true';
  }
  return handler(() => axios.get(url));
}

export const create = async (data: any) => {
  return handler(() => axios.post(baseURL, data));
}

export const update = async (id: string, data: any) => {
  const url = `${baseURL}/${id}`;
  return handler(() => axios.put(url, data));
}

export const findById = async (id: string) => {
  const url = `${baseURL}/${id}`;
  return handler(() => axios.get(url));
}

export const changePassword = async (id: string, adminPassword: string) => {
  const url = `${baseURL}/${id}/password`;
  return handler(() => axios.post(url, { adminPassword }));
}

const userService = {
  pureFetch,
  list,
  listCustomers,
  create,
  update,
  findById,
  changePassword
};

export default userService;
